import setts from "@/config/setts";

export default {
  // CLIENT_SECRET: setts.state ? "dhGQZV7wFZeEvo63hRmoOc1VqoT2VRrNNsDvhENK" : "SiiyotzHNq9Wy83zxgW1aOnZ0bTGT7Y270Ny2irH"
  CLIENT_SECRET: "SiiyotzHNq9Wy83zxgW1aOnZ0bTGT7Y270Ny2irH"
};
